export const initialDriverExpenseForm = {
  driverId: "",
  noOfDays: "",
  salaryPerDay: "",
  totalAmount: "",
};

export const normalizeDriverExpenses = (data) => {
  if (Array.isArray(data)) return data;
  return data?.driverExpenses || data?.expenses || data?.items || [];
};

export const filterDriverExpenses = (expenses, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return expenses;

  return expenses.filter((expense) => {
    const driverName = expense?.driverId?.name?.toLowerCase() || "";
    const driverCnic = expense?.driverId?.cnic?.toLowerCase() || "";
    const contact = expense?.driverId?.contactNumber?.toLowerCase() || "";
    const noOfDays = String(expense?.noOfDays || "").toLowerCase();
    const salaryPerDay = String(expense?.salaryPerDay || "").toLowerCase();
    const totalAmount = String(expense?.totalAmount || "").toLowerCase();

    return (
      driverName.includes(term) ||
      driverCnic.includes(term) ||
      contact.includes(term) ||
      noOfDays.includes(term) ||
      salaryPerDay.includes(term) ||
      totalAmount.includes(term)
    );
  });
};

export const formatDriverExpenseAmount = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "-";
  return new Intl.NumberFormat("en-PK", {
    style: "currency",
    currency: "PKR",
    maximumFractionDigits: 0,
  }).format(amount);
};

export const mapDriverExpenseToForm = (expense) => ({
  driverId:
    typeof expense?.driverId === "string"
      ? expense.driverId
      : (expense?.driverId?._id || ""),
  noOfDays: expense?.noOfDays !== undefined && expense?.noOfDays !== null ? String(expense.noOfDays) : "",
  salaryPerDay:
    expense?.salaryPerDay !== undefined && expense?.salaryPerDay !== null
      ? String(expense.salaryPerDay)
      : "",
  totalAmount:
    expense?.totalAmount !== undefined && expense?.totalAmount !== null
      ? String(expense.totalAmount)
      : "",
});

export const validateDriverExpenseForm = (form) => {
  const errors = {};

  if (!form.driverId) {
    errors.driverId = "Driver is required.";
  }

  if (!form.noOfDays || Number(form.noOfDays) <= 0) {
    errors.noOfDays = "No. of days must be greater than 0.";
  }

  if (!form.salaryPerDay || Number(form.salaryPerDay) <= 0) {
    errors.salaryPerDay = "Salary per day must be greater than 0.";
  }

  if (!form.totalAmount || Number(form.totalAmount) <= 0) {
    errors.totalAmount = "Total amount must be greater than 0.";
  }

  return errors;
};

export const buildDriverExpensePayload = (form) => ({
  driverId: form.driverId,
  noOfDays: Number(form.noOfDays),
  salaryPerDay: Number(form.salaryPerDay),
  totalAmount: Number(form.totalAmount),
});
